import { FormBuilderBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpFormBuilderBlock } from './AmpFormBuilderBlock';
import { FormBuilderBlock } from './FormBuilderBlock';

export const FormBuilderBlockMapping: BlockMapping<FormBuilderBlockData> = {
  invariant: [],
  width: 'GRID',
  Component: FormBuilderBlock,
  AmpComponent: AmpFormBuilderBlock,
};
